import { PagesName } from '@constants';
import { useRoutePath } from '@hooks/index';
import { useConfig } from '@hooks/useConfig';
import clsx from 'clsx';
import Link from '../../../components/Link';
import { useI18n } from '../../../hooks/useI18n';
import { useUIConfig } from '../../../hooks/useUIConfig';

const InnerPage = () => {
  const contactUsPage = useRoutePath(PagesName.ContactUsPage, true);
  const { t } = useI18n();
  const {
    notFoundPageRoutes = [
      {
        name: '404_home',
        path: '/',
        order: 1,
      },
    ],
  } = useConfig();
  return (
    <div className="page-inner page-inner--top pb-5 text-center">
      <div className="d-flex flex-column align-items-center">
        <h1 className="mb-0 mt-4">
          <b>{t('404_title')}</b>
        </h1>
        <h1 className="mb-1">
          <b>{t('404_title_sub')}</b>
        </h1>
        <p>{t('404_info')}</p>
        <div className="d-flex mt-3 mb-3 col-12 col-sm-5 justify-content-center">
          {notFoundPageRoutes?.map(route => {
            return (
              <Link to={route.path} className="btn btn-secondary mx-1 col">
                {t(route.name)}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const NotFoundPage = () => {
  const { headerNav } = useUIConfig();
  return (
    <main className={clsx('page-container', headerNav.active && 'pt-xl-4')}>
      <InnerPage />
    </main>
  );
};

export default NotFoundPage;
